/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import { isEmpty } from '../../utils/lodashExtend';
import DefaultPeople from "../../assets/images/partners/default-people.png";
import { shallowEqual, useSelector } from 'react-redux';
import { profilePreview } from '../../utils/externalProfile';

const PreviewExternalProfile = () => {
  const { previewEmployeeProfile } = useSelector(
    (store) => ({
      previewEmployeeProfile: store.Employee.previewEmployeeProfile,
    }),
    shallowEqual
  );

  const [employee, setEmployee] = useState(null);
  const cancel = () => {
    profilePreview(null);
  };

  useEffect(() => {
    if (previewEmployeeProfile) {
      setEmployee({ ...previewEmployeeProfile, ...previewEmployeeProfile?.externalProfile });
    }
  }, [previewEmployeeProfile]);
  return (
    <Modal
      isOpen={!isEmpty(previewEmployeeProfile)}
      close={cancel}
      toggle={cancel}
      scrollBehavior="inside"
      isCentered
    >
      {!isEmpty(employee) && (
        <div className="partner-detail-wrap">
          <div className="partner-detail-box">
            <div
              className="partner-photo"
              style={{
                backgroundImage: `url(${employee?.imageFile?.fileUrl || DefaultPeople
                  })`,
              }}
            />
            <div className="partner-info">
              <div>
                <div className="partner-name">{employee.name ? `${employee.name} 세무사` : ""}</div>
              </div>
              <table className="partner-info-table">
                <tbody>
                  {employee.companyName && (
                    <tr>
                      <th>소속 회사</th>
                      <td>{employee.companyName}</td>
                    </tr>
                  )}
                  {employee.mainTask && (
                    <tr>
                      <th>주요업무</th>
                      <td>
                        {employee.mainTask.split("\n").map((task, idx) => (
                          <div
                            key={idx}
                            dangerouslySetInnerHTML={{
                              __html: task || "",
                            }}
                          />
                        ))}
                      </td>
                    </tr>
                  )}
                  {employee.address && (
                    <tr>
                      <th>주소</th>
                      <td>
                        {employee.address} {employee.addressDetail}
                      </td>
                    </tr>
                  )}
                  {employee.tel && (
                    <tr>
                      <th>상담전화</th>
                      <td>
                        <a href={employee.tel} target="_blank">
                          {employee.tel}
                        </a>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {employee.description && <div className="partner-memo">{employee.description}</div>}
        </div>
      )}
    </Modal>
  );
};

export default PreviewExternalProfile;